import gsap from "gsap";
import { useRef, useEffect } from "react";
import { Header } from "components/frontComponents/header/Header";
import styles from "./styles.module.scss";

import mainImage from "assets/images/mainImagesmall.png";
import mainImage768 from "assets/images/mainImage768.png";
import mainImage1024 from "assets/images/mainImage1024.png";
import mainImage1440 from "assets/images/mainImage1440.png";
import { useNavigate } from "react-router-dom";
import { RouterPathEnum } from "shared/enums/commonEnums";

interface MainPageProps {
  scrollToRef: (ref: React.RefObject<HTMLElement>) => void;
  aboutRef: React.RefObject<HTMLElement>;
  featuresRef: React.RefObject<HTMLElement>;
  contactsRef: React.RefObject<HTMLElement>;
  mainRef: React.RefObject<HTMLElement>;
  activeSection: string;
}

export const MainScreen: React.FC<MainPageProps> = ({
  scrollToRef,
  aboutRef,
  featuresRef,
  contactsRef,
  mainRef,
  activeSection,
}) => {
  const imageRef1 = useRef(null);
  const imageRef2 = useRef(null);
  const navigate = useNavigate();
  useEffect(() => {
    if (imageRef1.current) {
      gsap.to(imageRef1.current, {
        rotation: 360,
        duration: 2,
        scale: 1.6,
        ease: "power2.inOut",
      });
    }

    if (imageRef2.current) {
      gsap.to(imageRef2.current, {
        rotation: 360,
        duration: 2,
        scale: 1.6,
        ease: "power2.inOut",
      });
    }
  }, []);

  return (
    <div className={styles.containerMainPage}>
      <Header
        fullWidth={true}
        scrollToRef={scrollToRef}
        aboutRef={aboutRef}
        featuresRef={featuresRef}
        contactsRef={contactsRef}
        mainRef={mainRef}
        activeSection={activeSection}
      />
      <div className={styles.mainPage}>
        <div className={styles.leftPart}>
          <div>
            <h1 className={styles.title}>ваше приключение</h1>
            <h1 className={styles.title}>к здоровью начинается здесь</h1>
          </div>
          <div className={styles.textholder}>
            <h3 className={styles.text}>
              Присоединяйтесь к увлекательной игре,
            </h3>
            <h3 className={styles.text}>
              которая изменит ваш образ жизни навсегда
            </h3>
          </div>

          <div className={styles.rightPartSmall}>
            <img
              src={mainImage768}
              ref={imageRef1}
              className={styles.image}
              alt=""
              loading="lazy"
            />
          </div>

          <div className={styles.buttonsholder}>
            <button
              className={styles.button}
              onClick={() => navigate(RouterPathEnum.Routing)}
            >
              Начать игру
            </button>
            <button
              className={styles.button}
              onClick={() => navigate(RouterPathEnum.Auth)}
            >
              Посмотреть результаты
            </button>
          </div>
        </div>
        <div className={styles.rightPart}>
          <img
            srcSet={`
          ${mainImage768} 800w,
          ${mainImage1024} 1200w,
          ${mainImage1440} 1400w,
           ${mainImage} 1900w,
        `}
            src={mainImage}
            ref={imageRef2}
            className={styles.image}
            alt=""
            loading="lazy"
          />
          <noscript>
            <img src={mainImage1024} alt="" />
          </noscript>
        </div>
      </div>
    </div>
  );
};
